export default function AiInsightsCard() {
  return (
    <div className="rounded-2.5xl bg-white dark:bg-boxdark border border-brand-green/35 dark:border-brand-green/20 p-5 sm:p-6 shadow-card mb-6">
      {/* Title */}
      <div className="flex items-center justify-between mb-4 pb-3 border-b border-brand-line/60 dark:border-strokedark">
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-[#12b98a] to-[#16EA9E] flex items-center justify-center text-brand-navy shadow-sm">
            <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
              <path d="M12 2a2 2 0 012 2c0 .74-.4 1.38-1 1.72V7h4a3 3 0 013 3v8a3 3 0 01-3 3H7a3 3 0 01-3-3v-8a3 3 0 013-3h4V5.72A2 2 0 0110 4a2 2 0 012-2zm-4 8a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm8 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-6 6h4a1 1 0 100-2h-4a1 1 0 100 2z" />
            </svg>
          </div>
          <h2 className="text-xs font-mono font-bold tracking-wider text-[#0e9c6c] dark:text-brand-green uppercase">
            AI-Generated Insights
          </h2>
          <span className="text-[10px] font-mono font-semibold px-2 py-0.5 rounded-md bg-brand-green-tint text-[#0a6b4a] dark:bg-emerald-950/40 dark:text-emerald-300 border border-brand-green/30">
            BETA
          </span>
        </div>
      </div>

      {/* 2 Insights Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Insight 1: Spending Decrease */}
        <div className="p-4 rounded-2xl bg-emerald-50/70 dark:bg-emerald-950/20 border border-emerald-200/70 dark:border-emerald-900/40 flex items-start gap-3">
          <div className="p-2 rounded-xl bg-white dark:bg-boxdark text-emerald-600 shadow-sm flex-shrink-0">
            <svg className="w-5 h-5 fill-current" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M12 13a1 1 0 100 2h5a1 1 0 001-1V9a1 1 0 10-2 0v2.586l-4.293-4.293a1 1 0 00-1.414 0L8 9.586 3.707 5.293a1 1 0 00-1.414 1.414l5 5a1 1 0 001.414 0L11 9.414 14.586 13H12z" clipRule="evenodd" />
            </svg>
          </div>
          <div>
            <div className="text-xs font-mono font-bold text-emerald-800 dark:text-emerald-300 uppercase tracking-wider">
              Spending Decrease
            </div>
            <p className="text-xs text-emerald-900 dark:text-bodydark1 mt-1 leading-relaxed">
              Great job! Your spending decreased by <strong>51%</strong> compared to the previous period.
            </p>
          </div>
        </div>

        {/* Insight 2: Vendor Concentration */}
        <div className="p-4 rounded-2xl bg-amber-50/70 dark:bg-amber-950/20 border border-amber-200/70 dark:border-amber-900/40 flex items-start gap-3">
          <div className="p-2 rounded-xl bg-white dark:bg-boxdark text-amber-600 shadow-sm flex-shrink-0">
            <svg className="w-5 h-5 fill-current" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
          <div>
            <div className="text-xs font-mono font-bold text-amber-800 dark:text-amber-300 uppercase tracking-wider">
              Vendor Concentration
            </div>
            <p className="text-xs text-amber-900 dark:text-bodydark1 mt-1 leading-relaxed">
              Microsoft represents <strong>66%</strong> of your spending. Consider diversifying or reviewing multi-seat license consolidation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
